var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.label,"prop":_vm.prop,"rules":_vm.rules}},[_c('el-checkbox-group',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._l((_vm.localdata),function(item,index){return [_c('el-checkbox',{key:index,attrs:{"label":item.id}},[_vm._v(_vm._s(item.answerContent))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }